import { render } from "./Drawing.vue?vue&type=template&id=2acce9ce&scoped=true"
import script from "./Drawing.vue?vue&type=script&lang=js"
export * from "./Drawing.vue?vue&type=script&lang=js"

import "./Drawing.vue?vue&type=style&index=0&id=2acce9ce&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2acce9ce"

export default script